const React = require("react");
const PropTypes = require("prop-types");

const Content = ({ children }) => {
  return <div className="pane__content">{children}</div>;
};

Content.propTypes = {
  children: PropTypes.node.isRequired,
};

module.exports = Content;
